import React from 'react';

const ScrollProgressIndicator = ({ scrollProgress, sections, scrollToSection, unlockedSections }) => {
  const getCurrentSection = () => {
    if (typeof window === 'undefined') return 0;
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    let currentIndex = 0;
    
    sections.forEach((section, index) => {
      const element = document.getElementById(section.id);
      if (element && element.offsetTop <= scrollPosition) {
        currentIndex = index;
      }
    });
    
    return currentIndex;
  };

  const currentIndex = getCurrentSection();
  const progress = (currentIndex / (sections.length - 1)) * 100;

  return (
    <div className="fixed top-1/2 right-8 transform -translate-y-1/2 z-50 hidden lg:block">
      <div className="flex flex-col items-center space-y-4">
        {/* Rocket Progress */}
        <div className="relative h-64 w-2 bg-gray-300 rounded-full overflow-hidden">
          <div 
            className="absolute bottom-0 w-full bg-gradient-to-t from-blue-500 to-purple-500 transition-all duration-500 ease-out"
            style={{ height: `${progress}%` }}
          />
          <div 
            className="absolute w-6 h-6 bg-blue-600 rounded-full transform -translate-x-1/2 transition-all duration-500 ease-out flex items-center justify-center"
            style={{ 
              left: '50%',
              bottom: `${progress}%`,
              transform: 'translateX(-50%) translateY(50%)'
            }}
          >
            <span className="text-white text-xs">🚀</span>
          </div>
        </div>
        
        {/* Section Indicators */}
        <div className="flex flex-col space-y-2">
          {sections.map((section, index) => (
            <button
              key={section.id}
              onClick={() => scrollToSection(section.id)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index <= currentIndex 
                  ? 'bg-blue-600 scale-125' 
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
              title={section.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScrollProgressIndicator;